<template>
    <section>

        <!-- ═══ VERSION DESKTOP (md et plus) ═══ -->
        <div class="d-none d-md-block">
            <v-carousel class="heightDiapo" :show-arrows="false" hide-delimiters cycle infinite>
                <div class="" ref="observedFirstDiapo" id="firstDiapo">
                    <v-carousel-item src="/Resources/images/Banner/homeDrinkingWater.jpg" cover style="position:relative;">               
                        <div style="position:absolute; top:40%; left:50%; transform: translate(-50%, -50%); width:75%;">
                            <h2 class="txt scroll-textes-up" :class="{ 'is-visible': firstDiapoVisible }">{{ $t('diapo.drinkingWater') }}</h2>
                        </div>
                    </v-carousel-item>
                </div>
                <div class="" ref="observedSecondDiapo" id="secondDiapo">
                    <v-carousel-item src="/Resources/images/Banner/homeTasteSmell.jpg" cover style="position:relative;">
                        <div style="position:absolute; top:40%; left:50%; transform: translate(-50%, -50%); width:75%;">
                            <h2 class="txt scroll-textes-right" :class="{ 'is-visible': secondDiapoVisible }">{{ $t('diapo.tasteSmell') }}</h2>
                            <v-col cols="12" class="d-flex justify-center mt-10">
                                <router-link class="scroll-btn-right" to="/analyseEau/#TypeWater" :class="{ 'is-visible': secondDiapoVisible }">
                                    <v-btn class="btn">{{ $t('diapo.tasteSmellBtn') }}</v-btn>
                                </router-link>
                            </v-col>
                        </div>
                    </v-carousel-item>
                </div>
                <div class="" ref="observedThirdDiapo" id="thirdDiapo">
                    <v-carousel-item src="/Resources/images/Banner/homeControl.jpg" cover style="position:relative;">
                        <div style="position:absolute; top:40%; left:50%; transform: translate(-50%, -50%); width:75%;">
                            <h2 class="txt scroll-textes" :class="{ 'is-visible': thirdDiapoVisible }">{{ $t('diapo.control') }}</h2>
                            <v-col cols="12" class="d-flex justify-center mt-10">
                                <router-link class="scroll-btn-left" to="/analyseEau" :class="{ 'is-visible': thirdDiapoVisible }">
                                    <v-btn class="btn">{{ $t('diapo.controlBtn') }}</v-btn>
                                </router-link>
                            </v-col>
                        </div>
                    </v-carousel-item>
                </div>
                <div class="" ref="observedFourDiapo" id="fourDiapo">
                    <v-carousel-item src="/Resources/images/Banner/homeQuality.jpg" cover style="position:relative;">
                        <div style="position:absolute; top:40%; left:50%; transform: translate(-50%, -50%); width:75%;">
                            <h2 class="txt scroll-textes-up" :class="{ 'is-visible': fourDiapoVisible }">{{ $t('diapo.quality') }}</h2>
                            <v-col cols="12" class="d-flex justify-center mt-10">
                                <router-link class="scroll-textes" to="/pompes_agricoles_commerciales_industrielles" :class="{ 'is-visible': fourDiapoVisible }">
                                    <v-btn class="btn">{{ $t('diapo.qualityBtn') }}</v-btn>
                                </router-link>
                            </v-col>
                        </div>
                    </v-carousel-item>
                </div>
            </v-carousel>
        </div>

        <!-- ═══ VERSION MOBILE (moins de md) ═══ -->
        <div class="d-md-none mobileBanner" :style="{ backgroundImage: 'url(/Resources/images/Banner/homeDrinkingWater.jpg)' }">
            <div class="mobileBannerOverlay">
                <h2 class="mobileBannerTitle">{{ $t('diapo.drinkingWater') }}</h2>
            </div>
        </div>

    </section>
</template>

<style scoped>
  @keyframes scale {
    0% { transform: scale(1); }
    100% { transform: scale(1.1); }
  }

  /* ═══ DESKTOP ═══ */
  .heightDiapo { height: 600px !important; }
  .txt {
    transition: transform 1s;
    text-align: center; font-weight: 700; line-height: 5vw;
    font-size: 4vw; color: rgb(var(--secondary));
    text-transform: uppercase !important;
    text-shadow: 1px 1px 3px white;
    width: 100%;
  }
  .btn {
    color: rgb(var(--tierce));
    background-color: rgb(var(--primary));
    font-size: 16px !important;
  }

  /* ═══ MOBILE ═══ */
  .mobileBanner {
    width: 100%;
    height: 220px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0; padding: 0;
  }
  .mobileBannerOverlay {
    background-color: rgba(255,255,255,0.55);
    padding: 12px 20px;
    border-radius: 6px;
    text-align: center;
  }
  .mobileBannerTitle {
    color: rgb(var(--secondary));
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    text-shadow: none;
    margin: 0;
  }

  @media handheld, only screen and (max-width: 960px) {
    .heightDiapo { height: 300px !important; }
    .btn { font-size: 12px !important; }
  }
</style>

<script>
    import pageTranslations from '../../public/Resources/i18N/global.json'

  export default {
    name: 'Diapo',
    data: () => ({
        firstDiapoVisible: false,
        secondDiapoVisible: false,
        thirdDiapoVisible: false,
        fourDiapoVisible: false
    }),
    async mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      await this.createObserverDiapo();
    },
    methods: {
        async createObserverDiapo() {
            const options = { threshold: 0.5 };
            const observer = new IntersectionObserver(this.handleIntersectionDiapo, options);
            const targets = [
                this.$refs.observedFirstDiapo,
                this.$refs.observedSecondDiapo,
                this.$refs.observedThirdDiapo,
                this.$refs.observedFourDiapo,
            ];
            targets.forEach(t => { if (t) observer.observe(t); });
        },
        handleIntersectionDiapo(entries) {
            entries.forEach((entry) => {
                const map = {
                    firstDiapo:  'firstDiapoVisible',
                    secondDiapo: 'secondDiapoVisible',
                    thirdDiapo:  'thirdDiapoVisible',
                    fourDiapo:   'fourDiapoVisible',
                };
                const key = map[entry.target.id];
                if (key) this[key] = entry.isIntersecting;
            });
        },
    },
    component: {}
  }
</script>